import { baseApi } from './base';
import { User, UserType } from '../../types/interfaces';

export const getUser = async (id: string) => {
  const response = await baseApi.get<User>(`/v1/private/user/${id}`);

  return response.data;
};

interface CreateUserData {
  name: string;
  email: string;
  password: string;
  type: UserType;
}

export const createUser = async (data: CreateUserData) => {
  const response = await baseApi.post(`/v1/public/user`, data);

  return response.data;
};
